import { h } from 'preact';
import ArrowRightIcon from 'utils/icon/icon-arrow-right.svg';
import { useMemo } from 'preact/hooks';
import MenuListItem from './menu-list-item';

const MenuList = ({ items, text, url, heading, large_images: largeImages }) => {
  const hasImages = useMemo(() => items.some((item) => item.image), [items]);
  return (
    <div className="p-24 border-b border-grey-300 tablet:border-0 tablet:p-0 tablet:[&:last-child>.column]:pr-0">
      <div className="eyebrow pb-12 tablet:border-b border-grey-300 mb-12">
        {heading}
      </div>
      <div className="flex flex-col column tablet:pr-20 lg:pr-40">
        {items.map((item) => (
          <MenuListItem key={item.id} {...item} largeImages={largeImages} />
        ))}
        {!!(text && url) && (
          <div
            className={`${hasImages ? 'mt-8 tablet:mt-0' : 'ml-24 tablet:m-0'}`}
          >
            <a
              href={url}
              className="body-1-semibold tablet:body-2-semibold w-fit hover:underline"
            >
              {text}
              <ArrowRightIcon className="inline-block  ml-8 lg:ml-10 w-12 h-auto" />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuList;
